module.exports = __webpack_public_path__ + "assets/img/llone.b38a39cf.png";